<template>
  <div class="error">
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: "ErrorMsg",

  props: {
    message: String,
  },
};
</script>

<style scoped>
.error {
  display: flex;
  justify-content: center;
}

.error p {
  font-family: "AvenirRoman";
  color: gray;
  border-radius: 0.375rem;
  font-weight: 500;
  background-color: white;
  padding: 0.5rem 1rem;
  border: 1px solid gray;
  box-shadow: 0 0 10px #ccc;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
}

.error p:hover {
  background-color: gray;
}

.error p:focus {
  outline: none;
}
</style>